import {ApiClient} from '@hconnect/apiclient'

import {Material} from '../types'

export const MaterialsQueryKey = 'materials'

export const materialsQueryOptions = (plantCode: string) => ({
  queryKey: [MaterialsQueryKey, plantCode] as const,
  queryFn: async ({signal}: {signal?: AbortSignal}) => {
    const response = await ApiClient.axiosInstance.get<Material[]>(
      `/plants/${plantCode}/materials`,
      {signal}
    )
    return response.data
  }
})
